import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { ModalController, Platform } from "@ionic/angular";
import SwiperCore, {
  Autoplay,
  FreeMode,
  Keyboard,
  Navigation,
  Pagination,
  Zoom,
} from "swiper";
// import { AnimationOptions } from "ngx-lottie";
import { Subscription, auditTime, distinctUntilChanged } from "rxjs";
import { Store } from "@ngrx/store";
import * as fromApp from "../../store/app.reducer";
import _ from "lodash";
// import moment from "moment";
import { ReservationCartComponent } from "../reservation-cart/reservation-cart.component";
import { TranslateService } from "@ngx-translate/core";
import * as ReservationsActions from "../../reservations/store/reservations.actions";
SwiperCore.use([Navigation, Autoplay, Keyboard, Pagination, Zoom, FreeMode]);

@Component({
  selector: "app-reservation-select-date",
  templateUrl: "./reservation-select-date.page.html",
  styleUrls: ["./reservation-select-date.page.scss"],
})
export class ReservationSelectDatePage implements OnInit, OnDestroy {
  @Input() artist: any;
  @Input() storeInfo: any;
  @Input() product_id: any;
  @Input() selectedLanguage: any;
  selectedProduct;
  cartProducts;
  allHours = [];
  isWobble = false;
  windowDimensions: any;
  columnSize: any;
  slideColors: string[] = [];
  letterColors: string[] = [];
  selectedDateIndex: any;
  selectedHourIndex: any; // Index of the selected artist (-1 means none selected)
  selectedHour: any;
  selectedDate: any;
  currentDate = new Date();
  columnSize2: number;
  reservationsFetchTimestamp = null; // Δεν φαινεται να κανει τιποτα προς το παρών

  public sliderOptions = {
    allowTouchMove: true,
    slidesPerView: "auto",
    direction: "horizontal",
    slideToClickedSlide: true,
    mousewheel: true,
    freeMode: true,
    freeModeMomentumBounce: false,
    freeModeMomentumRatio: 0.8,
    freeModeMomentumVelocityRatio: 0.8,

    centeredSlides: true,
    spaceBetween: 20,
  };

  private unsubscribeBackEvent: Subscription;
  private reservationCartModal: any;
  private subscriptions: Subscription[] = [];

  constructor(
    public modalCtrl: ModalController,
    private platform: Platform,
    private store: Store<fromApp.AppState>,
    private translateService: TranslateService
  ) {}

  public setSwiperInstance(swiper: SwiperCore) {
    // swiper.autoplay.start();
  }
  ngOnInit() {
    console.log("storeINfo", this.storeInfo);
    this.unsubscribeBackEvent = this.platform.backButton.subscribeWithPriority(
      300,
      () => {
        if (this.platform.is("android")) {
          this.modalCtrl.dismiss("back");
        }
      }
    );

    this.subscriptions.push(
      this.store
        .select("cart")
        .pipe(distinctUntilChanged())
        .pipe(auditTime(200))
        .subscribe((state) => {
          if (state && !_.isEqual(state.products, this.cartProducts)) {
            this.cartProducts = _.cloneDeep(state.products);
            if (this.cartProducts && this.cartProducts.length) {
              this.selectedProduct = _.find(_.cloneDeep(this.cartProducts), {
                product_id: this.product_id,
              });
            }
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("reservations")
        .pipe(auditTime(300))
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (
            state &&
            state.reservationsFetchTimestamp &&
            !_.isEqual(
              state.reservationsFetchTimestamp,
              this.reservationsFetchTimestamp
            )
          ) {
            this.reservationsFetchTimestamp = _.cloneDeep(
              state.reservationsFetchTimestamp
            );
            if (this.reservationCartModal) {
              this.reservationCartModal.dismiss();
              this.reservationCartModal = null;
            }
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("windowInfo")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (
            state &&
            !_.isEqual(this.windowDimensions, state.windowDimensions)
          ) {
            this.windowDimensions = _.cloneDeep(state.windowDimensions);
            // [size]="windowDimensions.width > 600 ? '6': '12'"
            if (this.windowDimensions.width > 700) {
              this.columnSize = 8;
              this.columnSize2 = 4;
            } else {
              this.columnSize = 12;
              this.columnSize2 = 12;
            }
          }
        })
    );
    this.slideColors = Array(this.artist.dates.length).fill("");
    this.letterColors = Array(this.artist.dates.length).fill("#000000");
  }

  filterHours() {
    const dayStart = this.getStartOfDay(this.selectedDate.hours[0].from);

    // Disable hours
    this.allHours = _.map(this.allHours, item => {
      const hour = item.hour;
      const split = _.split(hour, ":");
      let time = parseInt(split[0]) * 60 * 60 + parseInt(split[1]) * 60;
      time += dayStart;

      const found = _.find(this.selectedDate.hours, (range) => {
        const from = range.from;
        const to = range.to;
        if (time >= from && time <= to) {
          return true;
        } else {
          return false;
        }
      });

      if (found) {
        item.enabled = true;
      } else {
        item.enabled = false;
      }

      return item;
    });

    const first_index = _.findIndex(this.allHours, item => item.enabled);
    const last_index = _.findLastIndex(this.allHours, item => item.enabled);
    this.allHours = _.slice(this.allHours, first_index, last_index + 1);
  }

  getStartOfDay(timestamp: number): number {
    const date = new Date(timestamp * 1000); // Convert the day timestamp to milliseconds
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return Math.floor(date.getTime() / 1000);
  }

  secondsToTime(seconds) {
    let hours: any = _.floor(seconds / (60 * 60));
    let minutes: any = _.floor(
      (seconds - hours * 60 * 60) / 60
    ).toString();

    hours = hours % 24;
    hours = hours.toString();
    minutes = minutes % 60;
    minutes = minutes.toString();

    if (hours.length < 2) {
      hours = "0" + hours;
    }
    if (minutes.length < 2) {
      minutes = "0" + minutes;
    }
    return hours + ":" + minutes;
  }

  // getMinAndMaxHourFromSchedule(date) {
  //   let schedule;
  //   if (this.storeInfo.reservationAcceptScheduleActive) {
  //     schedule = this.storeInfo.reservationAcceptSchedule;
  //   } else {
  //     schedule = this.storeInfo.schedule;
  //   }

  //   const d = new Date(date.day * 1000);
  //   const day = d.getDay();
  //   const schedule_day = schedule[day];

  //   let periods;
  //   if (schedule_day.all_day) {
  //     periods = [
  //       {
  //         start: 0,
  //         stop: 60 * 60 * 24,
  //       },
  //     ];
  //   } else {
  //     periods = schedule_day.time_periods;
  //   }

  //   let find_min;
  //   let find_max;
  //   _.forEach(periods, (period) => {
  //     if (!find_min || period.start < find_min) {
  //       find_min = period.start;
  //     }
  //     if (!find_max || period.stop > find_max) {
  //       find_max = period.stop;
  //     }
  //   });

  //   find_min = _.ceil(find_min / (15 * 60)) * 15 * 60;
  //   //find_max = find_max - this.selectedProduct.service_duration_min * 60;
  //   find_max = _.floor(find_max / (15 * 60)) * 15 * 60;
  //   return {
  //     from: find_min,
  //     to: find_max
  //   };
  // }

  handleSlideClick(date: any, i: any) {
    if (this.selectedHourIndex === i) {
      // Same date
      return;
    }

    this.selectedHour = null;
    this.selectedHourIndex = null;
    this.slideColors = Array(this.artist.dates.length).fill("");
    this.letterColors = Array(this.artist.dates.length).fill("");
    // Perform the desired action when a slide is clicked

    this.slideColors[i] = "var(--ion-color-primary)";
    this.letterColors[i] = "var(--ion-color-primary-contrast)";
    this.selectedDateIndex = i;
    this.selectedDate = date;

    if (this.selectedDate.slotted_hours) {
      this.allHours = this.selectedDate.slotted_hours;
      console.log("new method slotted hours");
      return;
    }

    const time_slot_size = this.storeInfo.reservationTimeSlotSize || 15;
    this.allHours = [];
    // const start = this.selectedDate.hours[0].from;
    // const end = this.selectedDate.hours[this.selectedDate.hours.length - 1].to;
    // const schedule_period = this.getMinAndMaxHourFromSchedule(date);
    const start = 0;
    const end = 24 * 60 * 60;
    let current = start;
    while (current <= end) {
      this.allHours.push({
        hour: this.secondsToTime(current),
        enabled: false
      });
      current += time_slot_size * 60;
    }

    this.filterHours();
  }

  selectHour(index: number, item: any) {
    console.log("Clicked on item:", item);
    console.log("Clicked index:", index);
    if (this.selectedHour) {
      this.isWobble = !this.isWobble;
    }
    this.selectedHourIndex = index;
    this.selectedHour = item;
    setTimeout(() => {
      this.isWobble = false;
    }, 1000);
  }

  async submitDate() {
    this.store.dispatch(
      new ReservationsActions.SetReservationSelectedDate({
        date: _.cloneDeep(this.selectedDate),
        hour: _.cloneDeep(this.selectedHour),
      })
    );

    this.reservationCartModal = await this.modalCtrl.create({
      component: ReservationCartComponent,
      animated: true,
      backdropDismiss: false,
      componentProps: {
        selectedProduct: this.selectedProduct,
        selectedArtist: this.artist,
      },
      cssClass: "fullScreenModal",
    });
    await this.reservationCartModal.present();

    await this.reservationCartModal.onDidDismiss().then((data) => {
      this.reservationCartModal = null;
    });
  }

  ngOnDestroy(): void {
    if (this.unsubscribeBackEvent) {
      this.unsubscribeBackEvent.unsubscribe();
    }

    if (this.reservationCartModal) {
      this.reservationCartModal.dismiss();
      this.reservationCartModal = null;
    }
  }
}
